import React, { useEffect, useRef, useState } from 'react'
import { engine } from '../graphicEngine/engine'
import { getMousePos } from '../graphicEngine/getMousePos'
import { maprange } from "../functions/maprange"
import { drawPoint } from '../graphicEngine/drawPoint'
import { computePositionInCanvas } from '../graphicEngine/computePositionInCanvas'
import { drawBar } from '../graphicEngine/drawBar'
import supports from '../solve/supports'
import drawSupport from '../graphicEngine/drawSupport'
import solveHome from '../solve/solveHome'
import distributedToNodalForces from '../functions/distributedToNodalForces'
import { Anchor, Box, FormField, Layer, Nav, Tab, Table, TableBody, TableCell, TableHeader, TableRow, Tabs, TextInput, Tip } from 'grommet/components'
import { Sidebar } from 'grommet/components/Sidebar'
import { Grid } from 'grommet/components/Grid'
//import NavBar from './NavBar'
import { ArrowDownIcon, ContainerIcon, DashIcon, DotFillIcon, FoldDownIcon, HorizontalRuleIcon, ProjectRoadmapIcon } from '@primer/octicons-react'
import EISDiagrams from '../solve/EISDiagrams'
import viewPortConversion from '../functions/viewPortConversion'
import ResultsDisplay from './ResultsDisplay'


var dataGraphics
var xmapped;
var ymapped;
var nNodes = 0   //index dos nós
var nBar = 0     //index das barras
var nodes = []  //array com nós
var barNodes = []  //array com nós
var pos   //Posição do mouse geral
var nPoint = 1
var restrictedNodes = [] //vetor com os graus de liberdade de cada nó
var restrictedDisplacementVector //vetor atribuindo 0 aos graus de liberdade livre e 1 aos restritos
var forceVector = [] //Vetor de forças
var distributedMagnitudeX = [] //vetor que armazena as magnitudes das forças distribuidas
var distributedMagnitudeY = [] //vetor que armazena as magnitudes das forças distribuidas
var barPropsArray = [] //vetor que armazena as propriedades das barras
var Results = [] //resultados

function Canvas() {

  useEffect(()=>{
    generatecanvas()
    initMouseMoveListener()
  })

  const height = viewPortConversion().height
  const width = viewPortConversion().width

  const canvasRef = useRef(null)                                                //recebe a referência do canvas

  const [scale, setScale] = useState(25)
  const [flagPoints, setFlagPoints] = useState(true)
  const [refresh, setRefresh] = useState(true)
  const [nCoordBar, setNCoordBar] = useState(true)
  const [buttonState, setButtonState] = useState("node")
  const [listState, setListState] = useState("nodelist")
  const [dataState, setDataState] = useState("nodelist")    //Entrada de dados
  const [objectsViwerState, setObjectsViwerState] = useState(false)
  const [nx, setNx] = useState(1)
  const [ny, setNy] = useState(1)
  const [analysisSelection, setAnalysisSelection] = useState("0")
  const [isReady, setIsReady] = useState(false)
  const [openMenssage, setOpenMenssage] = useState(true)

  const [materialPropsIndex, setMaterialPropsIndex] = useState(0)
  const [young, setYoung] = useState(0)
  const [inertia, setInertia] = useState(0)
  const [area, setArea] = useState(0)

  const [nodeForce, setNodeForce] = useState(0)
  const [distributedForce, setDistributedForce] = useState(0)
  const [forceX, setForceX] = useState(0)
  const [forceY, setForceY] = useState(0)
  const [forceM, setForceM] = useState(0)
  const [distributedForceX, setDistributedForceX] = useState(0)
  const [distributedForceY, setDistributedForceY] = useState(0)

    const canvasStyle = {
        border: "1px solid black"
    }

    const generatecanvas = () => {
        const canvas = canvasRef.current
        dataGraphics = {
          canvas: canvas, 
          scale: scale, 
          nx: nx, 
          ny: ny,
          height: height,
          width: width
        }
        engine(dataGraphics)
        drawPoint(dataGraphics.canvas, nodes, dataGraphics.scale, dataGraphics.width, dataGraphics.height)
        drawSupport(dataGraphics.canvas, nodes, dataGraphics.scale, dataGraphics.width, dataGraphics.height, restrictedNodes)
        drawBar(dataGraphics.canvas, barNodes, scale, width, height, distributedMagnitudeX, distributedMagnitudeY)
    }

    const initMouseMoveListener = () => {
      const mouseMoveListener = (e) =>{
          pos = computePositionInCanvas(dataGraphics, e.clientX , e.clientY)              //envia a posição do mouse na tela para a função que calcula a posição referenciado no canvas
      }
      window.addEventListener("mousemove", mouseMoveListener)                     //"ouvindo" o evento de mover o mouse na tela (window) e atribuindo a função mouseMoveListener
  }

    const click = () => {
      xmapped = maprange(pos.x, 0, dataGraphics.width, 0, dataGraphics.scale)
      ymapped = maprange(pos.y, 0, dataGraphics.height, 0, (height/width)*dataGraphics.scale)

      //criando os nós
      if(buttonState === "node"){
        nodes[nNodes] = new Array(2)
        nodes[nNodes][0] = getMousePos(dataGraphics, xmapped, ymapped).xsnapped
        nodes[nNodes][1] = getMousePos(dataGraphics, xmapped, ymapped).ysnapped
        //criação do vetor com os graus de liberdade de cada nó
        restrictedNodes.push(0)
        nNodes = nNodes + 1
        //Adiciona 3 elementos (x,y,mz) ao vetor de forças por cada nó:
        for(let i = 0; i<3; i++){
          forceVector.push(0)
        }
      }

      if(buttonState === "bar"){
        //Busca todos os nós
        for(let i = 0; i < nodes.length; i++){
          //confere se as coordenadas do nó pressionado são iguais as coordenadas de algum dos nós existentes
          if(nodes[i][0] === getMousePos(dataGraphics, xmapped, ymapped).xsnapped && nodes[i][1] === getMousePos(dataGraphics, xmapped, ymapped).ysnapped){
            //armazena os pontos temporáriamente, para que as coordenadas sejam iguais nos nós e nas barras
            var tempPoint = [nodes[i][0], nodes[i][1]]

            //Criando as barras se há um nó no click
            if(nCoordBar){
              //mostrador de qual nó da barra
              nPoint = 2
              if(tempPoint !== undefined){
                barNodes[nBar] = new Array(2) //criando um subarray para as coordenadas e nós da barra
                barPropsArray[nBar] = new Array(2) //criando um sub array para as propiedades da barra
                barNodes[nBar][0] = tempPoint[0] //Coordenada x do primeiro nó associado
                barNodes[nBar][1] = tempPoint[1] //Coordenada y do primeiro nó associado
                barNodes[nBar][2] = i            //índice do primeiro nó associado
              }
              else{
                barNodes.splice(nBar,1)
              }
              setNCoordBar(false)
            }
    
            if(!nCoordBar){
              if(tempPoint === undefined){
                barNodes.splice(nBar,1)
              }
              else{
                barNodes[nBar][3] = tempPoint[0] //Coordenada x do segundo nó associado
                barNodes[nBar][4] = tempPoint[1] //Coordenada y do segundo no associado
                barNodes[nBar][5] = i            //Índice do segundo nó associado
                nBar = nBar + 1
                //adcionando a barra no vetor de forças distribuidas
                distributedMagnitudeX.push(0)
                distributedMagnitudeY.push(0)
                //mostrador de qual nó da barra
                nPoint = 1
              }
              setNCoordBar(true)
            }
          }
        }
      }
      setFlagPoints(!flagPoints)
    }

    //teste para receber as propriedades da barra
    // const sendDataToParent = (value) => {
    //   console.log(value)
    // }

    //Enviando as informações dos suportes nos nós para gerar o vetor de deslocamentos restritos
    const handdleSupport = (value, i) => {
      restrictedNodes[i] = value
      restrictedDisplacementVector = supports(restrictedNodes, nNodes)
      //dummystate só para renderizar a tela
      setRefresh(!refresh)
    }

    //Função para deletar os nós
    const deleteNode = (index) => {
      nodes.splice(index,1)
      //dummystate só para renderizar a tela
      setRefresh(!refresh)
      //diminui o índice dos nós para não ficar posição em falta
      nNodes = nNodes - 1
      //deletando do vetor dos graus de liberdade e das forças
      restrictedNodes.splice(index,1)
      forceVector.splice(index,3)
    }

    //Função para deletar as barras
    const deleteBar = (index) => {
      distributedMagnitudeX.splice(index,1)
      distributedMagnitudeY.splice(index,1)
      //delando a barra da lista de barras
      barNodes.splice(index,1)
      //deletando a propiedade da barra:
      barPropsArray.splice(index,1)
      //dummystate só para renderizar a tela
      setRefresh(!refresh)
      //diminui o índice dos nós para não ficar posição em falta
      nBar = nBar - 1
    }

    //Função que armazena as propriedades das barras:
    const barProps = () => {
      barPropsArray[materialPropsIndex][0] = young
      barPropsArray[materialPropsIndex][1] = inertia
      barPropsArray[materialPropsIndex][2] = area
    }

    //identica a função acima, mas adiciona a propiedades para todas as barras
    const propsToAll = () => {
      barPropsArray.map((item, index) => {
        barPropsArray[index][0] = young
        barPropsArray[index][1] = inertia
        barPropsArray[index][2] = area
        return barPropsArray
      })
    }

    //Função para dicionar forças ao vetor de forças
    const addForce = (nodeForce, forceX, forceY, forceM) => {
      forceVector[3*nodeForce] = forceVector[3*nodeForce]+parseInt(forceX)
      forceVector[3*nodeForce+1] = forceVector[3*nodeForce+1]+parseInt(forceY)
      forceVector[3*nodeForce+2] = forceVector[3*nodeForce+2]+parseInt(forceM)
    }

    //Função para adicionar forças distribuidas ao vetor de forças:
    const addDistributedForce = (distributedForce, distributedForceX, distributedForceY) => {
      distributedMagnitudeX[distributedForce] = distributedForceX
      distributedMagnitudeY[distributedForce] = distributedForceY
      var forces = distributedToNodalForces(distributedForceX, distributedForceY, barNodes, distributedForce)
      //Nó 1
      forceVector[(3*barNodes[distributedForce][2])] = forceVector[(3*barNodes[distributedForce][2])]+forces.node1X
      forceVector[(3*barNodes[distributedForce][2])+1] = forceVector[(3*barNodes[distributedForce][2])+1]+forces.node1Y
      forceVector[(3*barNodes[distributedForce][2])+2] = forceVector[(3*barNodes[distributedForce][2])+2]+forces.node1M
      //Nó 2
      forceVector[(3*barNodes[distributedForce][5])] = forceVector[(3*barNodes[distributedForce][5])]+forces.node2X
      forceVector[(3*barNodes[distributedForce][5])+1] = forceVector[(3*barNodes[distributedForce][5])+1]+forces.node2Y
      forceVector[(3*barNodes[distributedForce][5])+2] = forceVector[(3*barNodes[distributedForce][5])+2]+forces.node2M
    }

    //Função que chama o solver:
    const CallSolver = (analysisSelection, nNodes, nBar, nodes, barNodes, restrictedDisplacementVector, forceVector, distributedMagnitudeX, distributedMagnitudeY) => {
      Results = solveHome(analysisSelection, nNodes, nBar, nodes, barNodes, restrictedDisplacementVector, forceVector,barPropsArray, distributedMagnitudeX, distributedMagnitudeY)
      setIsReady(true)
    }

    //Componente para entrada de dados
    const dataEntry = () => {
      if(dataState === "materialsprops"){
        return(
          <Layer onClickOutside={() => setDataState(false)} margin='small' responsive={false}>
            <Box pad="large">
              <h2>Propiedades das barras</h2>
            <select onChange={(e)=>setMaterialPropsIndex(e.target.value)}>
              {barNodes.map((item, i) =>{
                return(<option value={i}>Barra {i+1}</option>)
              })}
            </select>
            <FormField label="Módulo de Young (kPa)">
              <TextInput placeholder="type here" value={young} onChange={(e) => setYoung(e.target.value)}/>
            </FormField>

            <FormField label="Inércia (m^4)">
              <TextInput placeholder="type here" value={inertia} onChange={(e) => setInertia(e.target.value)}/>
            </FormField>

            <FormField label="Área (m²)">
              <TextInput placeholder="m²" value={area} onChange={(e) => setArea(e.target.value)}/>
            </FormField>
            
                <button onClick={()=>{barProps()}}>Atribuir à barra</button>
                <button onClick={()=>{propsToAll()}}>Atribuir a todas as barras</button>
            </Box>
          </Layer>
        )
      }

      //Componente inserção das forças
      if(dataState === "nodalactions"){
        return(
          <Layer onClickOutside={() => setDataState(false)} responsive={false}>
            <Box justify='center' align='center' pad='large'>
              <h2>Inserção de força nodal (Em coordenadas globais)</h2>
              <label>Nó: 
                  <input
                    type="number"
                    onChange={(e) => setNodeForce(e.target.value - 1)}
                  />
                </label>
                <label>Força em X (kN): 
                  <input
                    type="number"
                    onChange={(e) => setForceX(e.target.value)}
                  />
                </label>
                <label>Força em Y (kN): 
                  <input
                    type="number"
                    onChange={(e) => setForceY(e.target.value)}
                  />
                </label>
                <label>Momento (kN.m): 
                  <input
                    type="number"
                    onChange={(e) => setForceM(e.target.value)}
                  />
                </label>
              <button onClick={()=>{addForce(nodeForce, forceX, forceY, forceM)}}> Adicionar Ações </button>
            </Box>
          </Layer>
        )
      }

      if(dataState === "distributedactions"){
        return(
          <Layer onClickOutside={() => setDataState(false)} responsive={false}>
            <Box justify='center' align='center' pad='large'>
              <h2>Inserção de força distribuida (em coordenadas locais)</h2>
              <Box>
                <Box direction='row' justify='left' align='center' pad='xxsmall'>
                  <label>Barra: 
                    <input
                      type="number"
                      onChange={(e) => setDistributedForce(e.target.value - 1)}
                    />
                  </label>
                </Box>

                <Box direction='row' justify='left' align='center' pad='xxsmall'>
                  <label>Direção X (kN/m): 
                    <input
                      type="number"
                      onChange={(e) => setDistributedForceX(e.target.value)}
                    />
                  </label>
                </Box>

                <Box direction='row' justify='left' align='center' pad='xxsmall'>
                  <label>Direção Y (kN/m): 
                    <input
                      type="number"
                      onChange={(e) => setDistributedForceY(e.target.value)}
                    />
                  </label>
                </Box>
                
                <button onClick={()=>{addDistributedForce(distributedForce, distributedForceX, distributedForceY)}}> Adicionar Ações </button>
              </Box>
            </Box>
          </Layer>
        )
      }
    }

    //Componente para listagem dos nós e das barras
    const ListsComponents = () => {
    //Listagem dos nós
      if(listState === "nodelist"){
        return(
          <Box justify='center' align='center' pad='xsmall'>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableCell scope="col" border="bottom">
                        Nó
                      </TableCell>
                      <TableCell scope="col" border="bottom">
                        Apoio
                      </TableCell>
                      <TableCell scope="col" border="bottom">
                        x (m)
                      </TableCell>
                      <TableCell scope="col" border="bottom">
                        y (m)
                      </TableCell>
                      <TableCell scope="col" border="bottom">
                        deletar
                      </TableCell>
                    </TableRow>
                  </TableHeader>
                <TableBody>
                {nodes.map((item, i) => {
                  return(
                    <TableRow>
                      <TableCell>
                        {i+1}
                      </TableCell>
                      <TableCell>
                        <select onChange={(e)=>{
                          handdleSupport(e.target.value, i)
                        }}>
                          <option value={0}>Livre</option>
                          <option value={1}>1º Genero</option>
                          <option value={2}>2º Genero</option>
                          <option value={3}>3º Genero</option>
                        </select>
                      </TableCell>
                      <TableCell>
                        {item[0]}
                      </TableCell>
                      <TableCell>
                        {item[1]}
                      </TableCell>
                      <TableCell>
                        <button onClick={()=>{deleteNode(i)}}> X </button>
                      </TableCell>
                    </TableRow>
                  )})}
              </TableBody>
              </Table>
                {/* <NodeInputSupports sendDataToParent={sendDataToParent} /> */}
          </Box>
        )
      }
      
      //Componente listagem das barras
      if(listState === "barlist"){
        return(
          <Box justify='center' align='center' pad='xsmall'>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    Barra
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    E (kPa)
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    I (m^4)
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    A (m²)
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Deletar barra
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {barNodes.map((item, i) => {
                  return(
                    <TableRow>
                      <TableCell scope="row">
                        <strong>{i+1}</strong>
                      </TableCell>
                      <TableCell>
                        {barPropsArray[i][0]}
                      </TableCell>
                      <TableCell>
                        {barPropsArray[i][1]}
                      </TableCell>
                      <TableCell>
                        {barPropsArray[i][2]}
                      </TableCell>
                      <TableCell>
                        <button onClick={()=>{deleteBar(i)}}> X </button>
                      </TableCell>
                    </TableRow>
                )})}
              </TableBody>
            </Table>
          </Box>
        )
      }

      //Análise
      if(listState === "analysis"){
        return(
          <Box justify='center' align='center' pad='xsmall'>
            <h2>Selecione o tipo de análise</h2>
            <Box>
            <select onChange={(e)=>setAnalysisSelection(e.target.value)}>
              <option value={0}>Análise linear</option>
              <option value={1}>Análise não linear geométrica</option>
            </select>
            <button onClick={() => {CallSolver(analysisSelection, nNodes, nBar, nodes, barNodes, restrictedDisplacementVector, forceVector, distributedMagnitudeX, distributedMagnitudeY)}}> Analisar </button>
            </Box>
          </Box>
        )
      }

      //resultados
      if(listState === "results" && isReady === true){
        var diagrams = EISDiagrams(Results.EIS, barNodes, forceVector, distributedMagnitudeX, distributedMagnitudeY)
        return(
          <div style={{overflow:'scroll'}}>
            <ResultsDisplay results={Results} nNodes={nNodes} nBar={nBar} diagrams={diagrams} type={analysisSelection}/>
          </div>
        )
      }
  }

  //Função de exibição da mensagem de abertura
  const Open = () => {
    return(
      <Layer onClickOutside={() => setOpenMenssage(false)} responsive={false}>
        <Box justify='left' align='center' pad='small'>
          <h2>Bem-vindo ao 2Frame!</h2>
          <p>Este programa esta em estágio beta!</p>
          <p>Desenvolvido como trabalho de conclusão de curso por João Fyllipy de Lima Nunes
            para o curso de engenharia civil do Centro de Tecnologia (CTEC) da Universidade Federal
            de Alagoas (UFAL).
          </p>
          <p>Este programa só deve ser utilizado como auxílio ou para fins acadêmicos</p>
          <p>O Usuário é inteiramente responsável pelo uso dos dados gerados.</p>
          <button onClick={() => setOpenMenssage(false)}> Ok! </button>
        </Box>
      </Layer>
    )
  }

  return (

    <Grid
      rows={['5%', 'fill']}
      columns={['8%', '92vw']}
      //gap="xsmall"
      areas={[
        // { name: 'header', start: [0, 0], end: [1, 0] },
        { name: 'nav', start: [0, 1], end: [0, 1] },
        { name: 'main', start: [1, 1], end: [1, 1] },
      ]}
    >
      {/* <Box gridArea="header"> */}
        {/* <NavBar /> */}
      {/* </Box> */}
      <Box gridArea="nav" direction='column'>
        <Sidebar background="dark-3" round="small"
          // footer={
          //   <div>
          //     {buttonState === "bar" ? <p>Ponto {nPoint}</p> : null}
          //   </div>
          // }

          header = {
            <Box justify='center' align='center' pad={{top: 'large'}}>
              <h3>2Frame</h3>
            </Box>
          }
        >
          <Nav gap='small' direction="column" fill='vertical' justify='center'>
          {buttonState === "bar" ? <p>Ponto {nPoint}</p> : null}
          <Tip content='Adicionar nó'>
            <Box border='all' round='xsmall' justify='center' align='center' pad='xsmall' onClick={()=>{setButtonState("node")}}>
                <Anchor color='white'>
                  <DotFillIcon />
                </Anchor>
            </Box>
          </Tip>

          <Tip content='Adicionar barra'>
            <Box border='all' round='xsmall' justify='center' align='center' pad='xsmall' onClick={()=>{setButtonState("bar")}}>
              <Anchor color='white'>
                <DashIcon />
              </Anchor>
            </Box>
          </Tip>

            <Box round='xsmall' justify='center' align='center' pad='xsmall' >
              <HorizontalRuleIcon size={24}/>
            </Box>

          <Tip content='Propriedades das barras'>
            <Box border='all' round='xsmall' justify='center' align='center' pad='xsmall' onClick={()=>{setDataState("materialsprops")}}>
              <Anchor color='white'>
                <ContainerIcon />
              </Anchor>
            </Box>
          </Tip>

          <Tip content='Adicionar força nodal'>
            <Box border='all' round='xsmall' justify='center' align='center' pad='xsmall' onClick={()=>{setDataState("nodalactions")}}>
              <Anchor color='white'>
                <ArrowDownIcon />
              </Anchor>
            </Box>
          </Tip>

          <Tip content='Adicionar força distribuída'>
            <Box border='all' round='xsmall' justify='center' align='center' pad='xsmall' onClick={()=>{setDataState("distributedactions")}}>
              <Anchor color='white'>
                <FoldDownIcon />
              </Anchor>
            </Box>
          </Tip>

            <Box round='xsmall' justify='center' align='center' pad='xsmall' >
              <HorizontalRuleIcon size={24}/>
            </Box>

          <Tip content='Análise, listas e resultados'>
            <Box border='all' round='xsmall' justify='center' align='center' pad='xsmall' onClick={()=>{setObjectsViwerState(true)}}>
              <Anchor color='white'>
                <ProjectRoadmapIcon />
              </Anchor>
            </Box>
          </Tip>
          </Nav>
        </Sidebar>
      </Box>

      <Box gridArea="main" background="light-1" justify='center' align='center' pad='xxsmall'>
          <Box justify='center' align='center' pad='xxsmall' direction='row'>
            <canvas ref={canvasRef} width={width} height={height} style={canvasStyle} onClick={(e) => click(e)}/>
          </Box>

          <Box direction='row' pad='xxsmall'>
            <Box pad={{horizontal: 'small'}}>
              <label>Escala em metros: 
                <input
                  type="range"
                  min="5"
                  max="80"
                  step="1"
                  value={scale}
                  onChange={(e) => setScale(e.target.value)}
                />
              </label>
            </Box>

            <Box pad={{horizontal: 'small'}}>
              <label>Intervalo em X: 
                <input
                  type="text" 
                  value={nx}
                  onChange={(e) => setNx(e.target.value)}
                />
              </label>
            </Box>

            <Box pad={{horizontal: 'small'}}>
            <label>intervalo em Y: 
              <input
                type="text" 
                value={ny}
                onChange={(e) => setNy(e.target.value)}
              />
            </label>
            </Box>
          </Box>

        {/* Componente para as listagens */}
        {objectsViwerState &&
          <Layer onClickOutside={() => setObjectsViwerState(false)} responsive={false}>
            <Box pad='large'>
              <Tabs>
                <Tab onClick={()=>{setListState("nodelist")}} title="Lista de Nós"></Tab>
                <Tab onClick={()=>{setListState("barlist")}} title="Lista de Barras"></Tab>
                <Tab onClick={()=>{setListState("analysis")}} title="Análise"></Tab>
                {isReady === true ? <Tab onClick={()=>{setListState("results")}} title="Resultados"></Tab> : null}
              </Tabs>
            </Box>
            {ListsComponents()}
          </Layer>
        }

        {/* Componente para entrada de dados */}
        {dataEntry()}

        {openMenssage === true ? <Open /> : null}

        <Box>
            <p>Developed by João Fyllipy 2023</p>
        </Box>
      </Box>
    </Grid>
  )
}

export default Canvas